import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAtariComponent } from './simple-icons-atari.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAtariComponent ],
    exports:      [ SimpleIconsAtariComponent ],
    bootstrap:    []
})
export class SimpleIconsAtariModule {}
